import { Request, Response } from '../../system/utilities/network.js';
import { toJS, runInAction } from 'mobx';
import moment from 'moment';
import langstore from '../../system/i18n/translator.js';
import {validateExtensionImage} from 'System/utilities/files.js';

const portafoglioreclami = async function(params,options){
  let loadingKey = 'portafoglioreclami';
  let localParams = this.routeParamsCacheGet("portafoglioreclamiParams");
  let dates = this.rangeToDates(this.config.format.dateRangeDefault);

  let  _params = {
    "PageNumber": localParams.PageNumber || 1,
    "da_dt_effettiva_reclamo": localParams.da_dt_ordine_cliente || dates.fr,
    "a_dt_effettiva_reclamo": localParams.a_dt_ordine_cliente || dates.to
  }

  this.loadingAdd(loadingKey);

  let response = await this.dataLayer({
    url: this.config.paths.apiURL + 'reclami',
    cacheAge: options && options.cacheAge ? options.cacheAge : this.config.cacheAPI.default,
    params: _params,
    userToken: this.userToken
  });

  runInAction( ()=> {
    if(response){
      this.dataPortafoglioreclami = response.data;
    }
    this.loadingRemove(loadingKey);
  });
}

const nuovoReclamoInit = async function(){
  await Promise.all([
    this.orderdetail(),
    this.colliordine()
  ]);

  this.dataReclamo = {
    type: null,
    section: 1,
    rows: [],
    pictures: [],
    note: ""
  };
}

const nuovoReclamoUpdate = function(key,value){
  let data = toJS(this.dataReclamo);
  data[key] = value;
  this.dataReclamo = data;

  if(key === "section"){
    setTimeout(()=>{
      let element = document.querySelector(".ts_view");
      element.scrollTop = element.scrollHeight;
    },1);

    // alert(element.scrollHeight);
    // element.scrollIntoView({ behavior: 'smooth', block: 'center'});
  }
}

const nuovoReclamoSend = async function(confirmModal){
  if(confirmModal === true){
    this.modalOpen("ModalConfirmReclamo");
  }
  else{

    let loadingKey = 'nuovoReclamoSend';
    this.loadingAdd(loadingKey);
    this.modalCloseAll();

    // dati reclamo
    let dataReclamo = toJS(this.dataReclamo);
    let dataOrder = this.dataOrder || {};
    let orderDetails = dataOrder.dettaglioOrdine || {};

    let {
        n_anno,
        c_numeratore,
        n_ordine,
        fg_stato_ordine_portale,
        ds_stato_ordine_portale,
        riferimento_cliente,
    } = orderDetails;

    let {
        section,
        type,
        rows,
        pictures,
        note
    } = dataReclamo;

    let ordineRows = rows.map(r=>{
      return r.RowNumber
    });
    let ordinePictures = pictures.map(p=>{
      return {
        name: p.name,
        description: p.name,
        file: p.source
      }
    });

    let _params = {
      n_anno,
      c_numeratore,
      n_ordine,
      descrizione_reclamo: note,
      persona_riferimento: riferimento_cliente,
      e_mail_riferimento: "",
      telefono_riferimento: "",
      rowsType: type,
      attachments: ordinePictures
    }

    if(type !== 'order') {
      _params.rowNumbers = ordineRows
    }

// let _params = {"data":{
//       "n_anno": 2020,
//       "c_numeratore": "OCI",
//       "n_ordine": 52463,
//       "descrizione_reclamo": "note",
//       "persona_riferimento": "riferimento_cliente",
//       "e_mail_riferimento": "ddd",
//       "telefono_riferimento": "ddd",
//       "rowNumbers": [1],
//       "attachments": [{
//           "nane": "ddd",
//           "description": "ddd",
//           "file": "data:image/png;base64,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"
//       }]
// }}

    let response = await this.dataLayer({
      url: this.config.paths.apiURL + 'reclami/insert',
      cacheAge: 1,
      params: _params,
      userToken: this.userToken
    });

    // Force update order detail after claim insert
    await this.orderdetail({n_anno, c_numeratore, n_ordine}, {cacheAge: 1, noLoad: true});

    runInAction(() => {
      if (response) {
        const { id_reclamo, n_anno_reclamo } = response.data || {};
        this.modalOpen("ModalSuccessReclamo", { closeOnOutsideClick: false, closeOnEscape: false, id_reclamo, n_anno_reclamo });
      }
      else {
        this.notificationAdd(langstore.t("reclami_send_error", "Invio non riuscito"), "ModalSuccessReclamo", 2000, "error");
      }
      this.loadingRemove(loadingKey);
    });

  }
}

const nuovoReclamoAddPictures = async function(id, file){

    let data = toJS(this.dataReclamo);
    var reader  = new FileReader();
    var source = "";
    var store = this;

    reader.onload = function(e)  {
      source = e.target.result;

      let f = data.pictures.find((p)=> p.id === id );

      // case: file already loaded
      if(f){
        return;
      }

      if(file.size >= 1024 * 1024 * 2){
        store.notificationAdd(langstore.t("reclami_imgformat_size","Il file è troppo pesante"),"nuovoReclamoAddPictures",2000,"error");  
        return;
      }

      // case: file not valid
      if( !validateExtensionImage(file.name) ){
        store.notificationAdd(langstore.t("reclami_imgformat_error","Il file non è un'immagine"),"nuovoReclamoAddPictures",2000,"error");
        return;
      }

      let item = {
        source: source,
        name: file.name,
        id
      }
      data.pictures.push(item);
      store.dataReclamo = data;

    }

    reader.readAsDataURL(file);
}

const nuovoReclamoRemovePictures = async function(id){
    let data = toJS(this.dataReclamo);

    data.pictures = data.pictures.filter((v)=>{
      return v.id !== id;
    });

    this.dataReclamo = data;

    // necessario azzerare stato input altrimenti non ricarica la stessa immagine
    // i dati immagine sono gestiti nello store e non nell'input
    let input = document.querySelector("#reclamo_file_input");
    input.value = "";
}

export {
  portafoglioreclami,
  nuovoReclamoSend,
  nuovoReclamoAddPictures,
  nuovoReclamoRemovePictures,
  nuovoReclamoUpdate,
  nuovoReclamoInit }